<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'locationcontent',
})
</script>
<template>
    <div v-if="data" >
      <contenttitle :data="data"></contenttitle>
      <div style="margin-top:50px;margin-bottom:50px;position: relative;">
        <img @load="loaded" :src="addip(data.pic)" style="width: 100%;height:auto;" />
        <div class="location-box "   :style="{left:getLocation(item.x),top:getLocation(item.y),color:data.color}" v-for="(item,i) in data.child" :key="i">
          <div :href="item.url" class="locatoin-title flex align-center justify-center">
            <span class="flex1">{{ item.name }}</span>
            <a  class="margin-left" :href="item.url" v-if="item.url"><ArrowRightOutlined  /></a>
          </div>
          <div class="locatoin-sub">
            <h5 v-if="item.sub">{{ item.sub }}</h5>
          </div>
        </div>
      </div>
    </div>
</template>
<script setup lang="ts" name="locationcontent">
import {defineComponent,defineProps,ref } from 'vue'
import {addip,colors} from '@/utils/util'
import {ArrowRightOutlined} from '@ant-design/icons-vue'
defineProps({
  data:Object
})
const w=ref<Number>(0)
const h=ref<Number>(0)
const getLocation=(num:FLoat)=>{
  let v='10%'
  if(num){
    v=num*100+"%"
  }
  return v
}
const loaded=(event)=>{
  w.value=event.target.offsetWidth
  h.value=event.target.offsetHeight
}
</script>
<style lang="less">
@import '@/style/main.less';
  .locationcontent{
    .location-box{
      padding: 10px;border-radius: 0 10px 10px 10px;transition: all linear .3s;
      position: absolute; background-color:@primary-opacity-50;color:@white;
      .location-dot{
        width:10px;height:10px;margin:10px;
        animation: locatondot 1s linear infinite;
      }
      .locatoin-title{font-size: 1.5em;font-weight: bold;cursor: pointer;}
      .locatoin-sub{display: none;padding:15px 0;}
    }
    .location-box:hover{
      background-color: @primary;
      .locatoin-sub{display: block;max-width: 300px;}
    }
  }
</style>
